import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { appConfig, serviceUrls } from './app.config';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: appConfig.authority,
    redirectUrl: appConfig.redirectUrl, // window.location.origin,
    postLogoutRedirectUri: `{appConfig.authority}/login `, //window.location.origin,
    clientId: appConfig.clientId,
    scope: 'openid email phone', //offline_access  per refreshtoken
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: Object.values(serviceUrls),
  }
}
